import { j as o } from "../jsx-runtime-ClSzPYp4.js";
import { Flex as r, Box as x } from "../Flexbox/Flexbox.mjs";
import a from "../branded/BrandedFooter/BrandedFooter.mjs";
import "../branded/BrandedFooter/footerContent.mjs";
import n from "../branded/BrandedHeader/BrandedHeader.mjs";
const f = ({ Header: t = n, Footer: e = a, renderContentAs: i = "main", children: m }) => /* @__PURE__ */ o.jsxs(r, {
  flexDirection: "column",
  height: "100%",
  children: [
    /* @__PURE__ */ o.jsx(t, {}),
    /* @__PURE__ */ o.jsx(r, {
      flexDirection: "column",
      as: i,
      flex: "1 0 auto",
      children: m
    }),
    /* @__PURE__ */ o.jsx(x, {
      mt: "auto",
      children: /* @__PURE__ */ o.jsx(e, {})
    })
  ]
});
export {
  f as default
};
